import { ModuleConfig } from "./module.types";
import { businessAdminModule } from "./business-admin/business-admin.module";

const modules: ModuleConfig[] = [businessAdminModule];

export const registerModule = (moduleConfig: () => ModuleConfig) => {
  modules.push(moduleConfig());
};

export const getModuleRoutes = () => {
  return modules.flatMap((module) => module.routes);
};

export const getModuleServices = () => {
  return modules.reduce((services, module) => {
    return { ...services, ...module.services };
  }, {});
};
